module.exports = __webpack_public_path__ + "static/media/washington-dc-46.baeb0419.jpg";